import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { MemoryTab } from '../../components/Pleri/components/Memory/MemoryTab';

export const Route = createFileRoute('/settings/memory')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <MemoryTab />
    </SettingsLayout>
  );
}
